function getDeliveryDate() {
  const daysOfWeek = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
  const monthsOfYear = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
  
  let today = luxon.DateTime.now().setZone('America/Mexico_City').toISO();
  today = new Date(today);

  const currentHour = today.getHours();
  const currentMinutes = today.getMinutes();
  const currentDay = today.getDay();

  let deliveryDate = new Date(today);

  // 🕐 Si es lunes a viernes antes de las 13:00
  if (currentDay >= 1 && currentDay <= 5 && (currentHour < 13 || (currentHour === 13 && currentMinutes === 0))) {
    return "hoy mismo";
  }

  // 🕒 Lunes a jueves después de las 13:00 → al día siguiente
  if (currentDay >= 1 && currentDay <= 4 && currentHour >= 13) {
    deliveryDate.setDate(today.getDate() + 1);
  }

  // 📦 Viernes después de las 13:01, Sábado o Domingo → hasta lunes
  if ((currentDay === 5 && currentHour >= 13) || currentDay === 6 || currentDay === 0) {
    const daysUntilMonday = (8 - currentDay) % 7; // 5=>3, 6=>2, 0=>1
    deliveryDate.setDate(today.getDate() + daysUntilMonday);
  }

  const dayName = daysOfWeek[deliveryDate.getDay()];
  const monthName = monthsOfYear[deliveryDate.getMonth()];
  const day = deliveryDate.getDate();

  return `${dayName}, ${day} de ${monthName}`;
}

document.addEventListener('DOMContentLoaded', function() {
  const dateElement = document.getElementById('date__estimated');
  if (dateElement) {
    const date = getDeliveryDate();
    dateElement.textContent = date;
  }
});
